/* AutoLeathers — paid landing page behaviour. WP7, 6 Aug 2026.
   Three jobs: swap the hero photo, drive the mobile sticky bar, and report a
   WhatsApp click (D1, 8 Aug 2026).

   ⚠️ READ THIS BEFORE TOUCHING THE TRACKING BLOCK.

   No tag is loaded here and no pixel is created here. Both `gtag` and `fbq` already
   exist in the MAIN WINDOW on every storefront page, put there by Shopify's own
   channel apps — verified live on a paid page on 8 Aug 2026:

     window.google_tag_manager → GT-5TGBQZCM, G-KVCERL6MFJ, AW-16498491963
     dataLayer                 → config G-KVCERL6MFJ / AW-16498491963 (send_page_view:false)
     window.fbq.instance       → one pixel, 962304766380360

   So this file only sends EVENTS on the feeds that are already there. That is the
   whole reason it is safe: a second GA4 config would double-count every purchase and
   a second fbq('init') would double-count every Meta event. Never add either.
   If `gtag` or `fbq` is missing (consent declined, tracker blocker) the call is
   skipped silently — that is correct behaviour, not a bug to "fix" with a fallback.

   The GTM container GTM-PTSTN4CP is NOT here: it runs inside the Shopify custom-pixel
   sandbox iframe, so a main-window dataLayer.push would never reach it. Don't try. */
(function () {
  'use strict';

  /* Google Ads conversion action `AL | WhatsApp Click | Website | Shopify`
     (ctId 7713620798) — Secondary, Count = One, no value. Created 8 Aug 2026. */
  var ADS_WHATSAPP_CONVERSION = 'AW-16498491963/RvceCL6Gkt4cELuEjLs9';

  /* The store's only GA4 property. Named explicitly so the event cannot leak into
     the Google Ads destination as a stray GA4 event. */
  var GA4_MEASUREMENT_ID = 'G-KVCERL6MFJ';

  /* ---- hero photo swap -------------------------------------------------- */
  function initGallery() {
    document.querySelectorAll('[data-paid-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var main = document.getElementById(thumb.getAttribute('aria-controls'));
        if (!main) return;

        main.src = thumb.dataset.src;
        main.srcset = thumb.dataset.srcset || '';
        main.alt = thumb.dataset.alt || '';

        thumb.parentElement.querySelectorAll('[data-paid-thumb]').forEach(function (sibling) {
          sibling.setAttribute('aria-current', sibling === thumb ? 'true' : 'false');
        });
      });
    });
  }

  /* ---- sticky bar -------------------------------------------------------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-paid-sticky]');
    if (!bar) return;

    var productInfo = document.querySelector('product-info');
    var submitButton = productInfo && productInfo.querySelector('button[type="submit"][name="add"]');
    if (!submitButton) {
      bar.remove();
      return;
    }

    document.body.classList.add('paid-lp-has-sticky');

    /* The sticky Add to cart is a proxy for the real one, never a second form.
       That keeps the variant, the quantity rules and the theme's own cart events
       identical to a normal add — nothing here has to be kept in sync. */
    var proxy = bar.querySelector('[data-paid-sticky-add]');
    if (proxy) {
      proxy.addEventListener('click', function () {
        submitButton.click();
      });
    }

    /* Mirror the live price and the sold-out state out of the buy box. Dawn
       replaces the whole price node on every variant change, so watch the parent. */
    var priceTarget = bar.querySelector('[data-paid-sticky-price]');
    var priceSource = productInfo.querySelector('[id^="price-"]');

    /* Read the specific price node, not the block's text: Dawn keeps a
       visually-hidden "Regular price" label in there that innerText picks up. */
    function syncPrice() {
      if (!priceTarget || !priceSource) return;
      var block = priceSource.querySelector('.price');
      var onSale = block && block.classList.contains('price--on-sale');
      var node = priceSource.querySelector(onSale ? '.price-item--sale' : '.price-item--regular');
      var text = node && node.textContent.trim();
      if (text) priceTarget.textContent = text;
    }

    /* Write into the label span, never the button itself — the button also holds
       an inline SVG icon that textContent would delete. */
    var proxyLabel = proxy && proxy.querySelector('[data-paid-sticky-label]');

    function syncAvailability() {
      if (!proxy) return;
      var soldOut = submitButton.hasAttribute('disabled');
      proxy.disabled = soldOut;
      var text = soldOut ? 'Sold out' : proxy.dataset.label || 'Add to cart';
      if (proxyLabel) {
        proxyLabel.textContent = text;
      } else {
        proxy.textContent = text;
      }
    }

    syncPrice();
    syncAvailability();

    if (window.MutationObserver) {
      new MutationObserver(function () {
        syncPrice();
        syncAvailability();
      }).observe(productInfo, { childList: true, subtree: true, attributes: true });
    }

    /* Only show the bar once the real buy panel has scrolled away, so the page
       never carries two competing Add to cart buttons in the same viewport. */
    var anchor = document.querySelector('.al-buypanel') || submitButton;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          bar.setAttribute('data-visible', entries[0].isIntersecting ? 'false' : 'true');
        },
        { rootMargin: '0px 0px -25% 0px' }
      ).observe(anchor);
    } else {
      bar.setAttribute('data-visible', 'true');
    }
  }

  /* ---- WhatsApp click tracking ------------------------------------------- */

  /* Every WhatsApp button on the page carries `data-paid-lp-whatsapp` and the
     `data-wa-*` set written by snippets/paid-whatsapp.liquid. One delegated listener
     on the document covers all of them — including the mobile sticky bar, which is a
     separate section and a separate code path, and including any button that a future
     section adds. */
  function initWhatsAppTracking() {
    document.addEventListener(
      'click',
      function (event) {
        var link = event.target && event.target.closest
          ? event.target.closest('[data-paid-lp-whatsapp]')
          : null;
        if (link) reportWhatsAppClick(link);
      },
      true
    );
  }

  function reportWhatsAppClick(link) {
    var data = link.dataset || {};

    /* Keep these parameter names stable — they are what the GA4 report is built on. */
    var params = {
      source_code: data.waCode || '',
      ad_channel: data.waChannel || '',
      button_position: data.waPosition || 'unknown',
      vehicle: data.waVehicle || '',
      product_handle: data.waProduct || '',
      page_handle: pageHandle()
    };

    /* GA4. `send_to` pins it to the one measurement ID so it cannot also be
       delivered to the Ads destination as an unnamed event. */
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', 'whatsapp_click', merge({ send_to: GA4_MEASUREMENT_ID }, params));
      } catch (e) {
        /* never let a tag error break the click through to WhatsApp */
      }

      /* Google Ads secondary conversion. No value and no transaction_id: the manual
         is explicit that a WhatsApp click is a funnel diagnostic, not revenue. */
      try {
        window.gtag('event', 'conversion', { send_to: ADS_WHATSAPP_CONVERSION });
      } catch (e) {}
    }

    /* Meta, on the pixel Shopify already initialised. `trackCustom`, never `init`. */
    if (typeof window.fbq === 'function') {
      try {
        window.fbq('trackCustom', 'WhatsAppClick', params);
      } catch (e) {}
    }
  }

  function pageHandle() {
    var parts = window.location.pathname.split('/');
    return parts[parts.length - 1] || '';
  }

  function merge(target, source) {
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
  }

  function init() {
    initGallery();
    initStickyBar();
    initWhatsAppTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
